import { render, staticRenderFns } from "./TradeControls.vue?vue&type=template&id=5016a39c&scoped=true&"
import script from "./TradeControls.vue?vue&type=script&lang=ts&"
export * from "./TradeControls.vue?vue&type=script&lang=ts&"
import style0 from "./TradeControls.vue?vue&type=style&index=0&id=5016a39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016a39c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VIcon,VRow,VToolbar})
